import EfBanner from '@elem/ui/ef-banner';
import EfEmarsysEmail from '@elem/ui/ef-emarsys-email';
import { useProductStore } from '../../../ProductProvider';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function TheComp() {
    const { t } = useLang('delta3Plus');
    const { pageStatus } = useProductStore();

    const IS_A = pageStatus === 'statusA';

    const auConfigs = {
        label: IS_A ? t('A_label') : 'New Release',
        title: IS_A ? t('A_title') : 'EcoFlow DELTA 3 Plus',
        desc: t('A_desc'),
        pc: 'https://websiteoss.ecoflow.com/upload/image/1737426095474/KV.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1739157351958/KV-M.jpg',
        gtm_title_name: IS_A ? t('A_title') : 'EcoFlow DELTA 3 Plus',
        gtm_position: 'Product Detail_1',
        hasEmail: IS_A, // 预热页才需要邮件
        emailChildren: (
            <div className="Banner-email">
                <EfEmarsysEmail
                    theme="white"
                    tipsObj={{
                        placeholder: 'Enter your email for launch updates and exclusive discounts.',
                        tipsEmpty: 'Please enter the email.',
                        tipsTypeError: 'Please enter a valid email address.',
                        successTips: 'Subscription successful !',
                        tipsCheck: 'Please consent to the Terms of Use and Privacy Policy.',
                        tipsFailed: 'Failed, please try again or contact us.',
                    }}
                    needTerms
                    termsHtml="*I agree to EcoFlow's <a href='https://account.ecoflow.com/agreement/en-au/PrivacyPolicy.html' target='_blank'>Privacy Policy</a> and <a href='https://account.ecoflow.com/agreement/en-au/TermsOfUse.html' target='_blank'>Terms of Service</a>."
                    isMulti
                    contactListId={['89990871']}
                    fields={[
                        {
                            id: '4433',
                            type: 'single',
                            value: 1,
                            overwrite: true,
                        },
                        {
                            id: '11571',
                            type: 'multiple',
                            value: [6],
                            overwrite: false,
                        },
                    ]}
                />
            </div>
        ),
        btn_text: IS_A ? '' : t('A_btn'),
        btn_link: 'https://www.youtube.com/embed/J4iuggnpDpA',
    };

    return (
        <div className={styles.TheComp}>
            <EfBanner {...auConfigs} />
        </div>
    );
}
